import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import n from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/resize-observer/src/delegate.js";
import { onMounted as o, watch as a, onBeforeUnmount as s } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function p(r, t) {
  t && (o(() => {
    const {
      value: e
    } = r;
    e && n.registerHandler(e, t);
  }), a(r, (e, i) => {
    i && n.unregisterHandler(i);
  }, {
    deep: !1
  }), s(() => {
    const {
      value: e
    } = r;
    e && n.unregisterHandler(e);
  }));
}
export {
  p as useOnResize
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/composable/use-resize.js
// module id = 896
// module chunks = 41